/**
 * Widget type constants
 */
export const WIDGET_TYPES = {
  METRIC: "metric",
  LIST_SIMPLE: "list-simple",
  LIST_TABLE: "list-table",
  CHART_BAR: "chart-bar",
  CHART_PIE: "chart-pie",
  MAP: "map",
  GENERIC: "generic"
} as const;

/**
 * Widget type values as array for iteration
 */
export const WIDGET_TYPE_VALUES = Object.values(WIDGET_TYPES);
